import React, { ChangeEvent, ComponentProps, forwardRef, memo } from 'react'

import { DEFAULT_NUMBER_PRECISION, DEFAULT_NUMBER_SCALE } from '@surglogs/util'

import { useHandler, useNumberMask } from '@surglogs-app/hooks'

import { Input } from './Input'

interface NumberInputProps
  extends Omit<
    ComponentProps<typeof Input>,
    'defaultValue' | 'value' | 'onChange'
  > {
  defaultValue?: number | string
  integer?: boolean
  onChange?: (value: string) => void
  onlyPositive?: boolean
  precision?: number
  scale?: number
  value?: number | string
}

export const NumberInput = memo(
  forwardRef<HTMLInputElement, NumberInputProps>(
    (
      {
        scale = DEFAULT_NUMBER_SCALE,
        onChange,
        precision = DEFAULT_NUMBER_PRECISION,
        onlyPositive = false,
        integer = false,
        ...rest
      },
      ref,
    ) => {
      const mask = useNumberMask({ integer, precision, scale, onlyPositive })
      const handleChange = useHandler((e: ChangeEvent<HTMLInputElement>) => {
        const { value } = e.currentTarget
        const [, normalizedValue] = value.match(mask) || [undefined, value]

        return typeof onChange === 'function'
          ? onChange(String(normalizedValue))
          : normalizedValue
      })

      return <Input {...rest} {...{ onChange: handleChange, ref }} />
    },
  ),
)
